import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const Impact = () => {
  return (
    <Grid container padding={{ xs: "30% 0%", sm: "4% 2% 7% 0%" }}>
      <Grid items xs={12} sm={12}>
        <Typography
          variant="h3"
          fontWeight={700}
          padding={{ xs: "4% 0%", sm: "4% 0%" }}
          color={"#fff"}
          textAlign={"center"}
        >
          Projected Impact At A Glance
        </Typography>
      </Grid>
      <Grid
        items
        xs={12}
        sm={2.8}
        textAlign={"center"}
        padding={{ xs: "20% 0% 10% 0%", sm: "0%" }}
      >
        <Typography
          variant={"h3"}
          color={"#fff"}
          fontWeight={700}
          paddingBottom={"2%"}
        >
          $15k-$50k
        </Typography>
        <Typography variant={"body1"} color={"#fff"}>
          Seed Grant
        </Typography>
      </Grid>
      <Divider
        orientation="vertical"
        variant="middle"
        flexItem
        color={"#fff"}
      />
      <Grid
        items
        xs={12}
        sm={2.8}
        textAlign={"center"}
        padding={{ xs: "20% 0% 10% 0%", sm: "0%" }}
      >
        <Typography
          variant={"h3"}
          color={"#fff"}
          fontWeight={700}
          paddingBottom={"2%"}
        >
          $50k-$150k
        </Typography>
        <Typography variant={"body1"} color={"#fff"}>
          Growth-Stage Investments
        </Typography>
      </Grid>
      <Divider
        orientation="vertical"
        variant="middle"
        flexItem
        color={"#fff"}
      />
      <Grid
        items
        xs={12}
        sm={1.8}
        textAlign={"center"}
        padding={{ xs: "20% 0% 10% 0%", sm: "0%" }}
      >
        <Typography
          variant={"h3"}
          color={"#fff"}
          fontWeight={700}
          paddingBottom={"2%"}
        >
          <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
            {({ isVisible }) => (
              <div style={{ height: 55 }}>
                {isVisible ? (
                  <CountUp start={0} end={4} duration={2} useEasing={true} />
                ) : null}
              </div>
            )}
          </VisibilitySensor>
        </Typography>
        <Typography variant={"body1"} color={"#fff"}>
          Focus Areas
        </Typography>
      </Grid>
      <Divider
        orientation="vertical"
        variant="middle"
        flexItem
        color={"#fff"}
      />
      <Grid
        items
        xs={12}
        sm={1.8}
        textAlign={"center"}
        padding={{ xs: "20% 0% 10% 0%", sm: "0%" }}
      >
        <Typography
          variant={"h3"}
          color={"#fff"}
          fontWeight={700}
          paddingBottom={"2%"}
        >
          <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
            {({ isVisible }) => (
              <div style={{ height: 55 }}>
                {isVisible ? (
                  <CountUp start={0} end={100} duration={2} useEasing={true} />
                ) : null}
              </div>
            )}
          </VisibilitySensor>
        </Typography>
        <Typography variant={"body1"} color={"#fff"}>
          Number of StartUps
        </Typography>
      </Grid>
      <Divider
        orientation="vertical"
        variant="middle"
        flexItem
        color={"#fff"}
      />
      <Grid
        items
        xs={12}
        sm={2}
        textAlign={"center"}
        padding={{ xs: "20% 0% 10% 0%", sm: "0%" }}
      >
        <Typography
          variant={"h3"}
          color={"#fff"}
          fontWeight={700}
          paddingBottom={"2%"}
        >
          <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
            {({ isVisible }) => (
              <div style={{ height: 55 }}>
                {isVisible ? (
                  <CountUp start={0} end={28} duration={2} useEasing={true} />
                ) : null}
              </div>
            )}
          </VisibilitySensor>
        </Typography>
        <Typography variant={"body1"} color={"#fff"}>
          Focus Countries
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Impact;
